import React, { useState, useEffect } from 'react';
import ChatWeb from './ChatWeb';
import ChatMobile from './ChatMobile';

// Interfaces
interface OriginalContactData {
  id: number;
  name: string;
  tagId: number | null;
  number: string;
  avatarUrl: string | null;
  email: string;
  notes: string | null;
  sectorId: number;
  isActive: boolean;
  priority: string;
  contactStatus: 'Novo' | 'Qualificado' | 'Não qualificado' | string;
  aiActive: number;
  assignedTo: number | null;
  assignedToName?: string | null;
  createdAt: string;
  profilePicture?: string;
  lastMessage?: string;
  lastMessageTime?: string;
  unreadCount?: number;
  is_viewed: boolean;
  archived?: boolean;
}

type ContactData = OriginalContactData;

type ChatProps = {
  hasNewMessages?: { [contactId: number]: boolean };
  setHasNewMessages?: (newState: { [contactId: number]: boolean }) => void;
  contacts?: ContactData[];
  setContacts?: React.Dispatch<React.SetStateAction<ContactData[]>>;
  loadMoreContacts?: () => void;
  hasMoreContacts?: boolean;
  isLoadingMoreContacts?: boolean;
  totalContacts?: number;
  archivedCount?: number;
  favoritesCount?: number;
  unreadCount?: number;
  setUnreadCount?: (updater: number | ((prev: number) => number)) => void;
  whatsappGroupsCount?: number;
};

const Chat: React.FC<ChatProps> = (props) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      const userAgent = navigator.userAgent;
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      const isMobileDevice = mobileRegex.test(userAgent);
      const isSmallScreen = window.innerWidth <= 768;

      setIsMobile(isMobileDevice || isSmallScreen);
    };

    // Verificar inicialmente
    checkIsMobile();

    // Adicionar listener para mudanças de tamanho da tela
    const handleResize = () => {
      checkIsMobile();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Renderizar o componente apropriado baseado no dispositivo
  if (isMobile) {
    return <ChatMobile {...props} />;
  } else {
    return <ChatWeb {...props} />;
  }
};

export default Chat; 